<div class="mgt10">
    @for (toolRow of toolRows; track toolRow) {
        <ul
            class="nav nav-tabs"
            role="tablist">
            @for (tool of toolRow.tools; track tool) {
                <li role="presentation">
                    <a
                        role="tab"
                        data-toggle="tab"
                        class="icon-tab">
                        <button
                            type="button"
                            class="btn btn-default nlr-icon-btn"
                            [title]="tool.tooltip"
                            [ngClass]="{active: tool.id === selectedFeatureTableTool?.id}"
                            (click)="changeSelectedFeatureTableTool(tool)"
                            [disabled]="disabled">
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.iconClass"></i>
                        </button>
                    </a>
                </li>
            }
        </ul>
    }

    <!-- Tab panes -->
    <div class="tab-content">
        <li
            role="presentation"
            class="divider"></li>
        @for (toolRow of toolRows; track toolRow) {
            @for (tool of toolRow.tools; track tool) {
                @if (selectedFeatureTableTool?.id === tool.id) {
                    <nlr-feature-business-table
                        id="{{selectedFeatureTableTool.type}}FeatureTableTab"
                        role="tabpanel"
                        class="tab-pane active"
                        [disabled]="disabled"
                        [isDesignTabActive]="isDesignTabActive"
                        [editorConfig]="editorConfig"
                        [tool]="selectedFeatureTableTool">
                    </nlr-feature-business-table>
                }
            }
        }
    </div>
</div>
